<div style="padding: 24px;background: #0E0D0D;">
    <div class="title ">Your EOI application has been submitted successfully.</div>
    <div class="value">Please wait for the developer to approve your application</div>
    <div style="text-align: end">
        <button mat-flat-button class="button-style" (click)="close()">Got it</button>
    </div>
</div>